import { NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ButtonModule } from '@openng/optimus-ui/button';
import { DialogModule } from '@openng/optimus-ui/dialog';

import { ChunkNotFoundDialogService } from '@app/theme/services/chunk-not-found-dialog.service';

@Component({
    selector: 'cor-chunk-not-found-dialog',
    templateUrl: './chunk-not-found-dialog.component.html',
    imports: [DialogModule, ButtonModule, NgOptimizedImage],
})
export class ChunkNotFoundDialogComponent {
    protected readonly chunkNotFoundDialogService = inject(ChunkNotFoundDialogService);

    reloadPage() {
        window.location.reload();
    }
}
